//@ts-nocheck
import { Transforms, Node, Editor, Element, Range } from 'slate';

const excludedElements = ['table', 'tbody', 'tr', 'thead', 'doc', 'ul', 'ol', 'fragment']


/** element level  */
export const setElementClass = (editor, classText, selection) => {
  if (!selection) return
  if (Range.isCollapsed(selection)) {
    for (const [node, path] of Editor.nodes(editor, { at: selection,  match: (n: JsonNode) => Element.isElement(n) && !excludedElements.includes(n.type) })) {
        const oldAttributes = node.attrs
        const elementAttribute = {
          attrs: {
            ...oldAttributes,
            "class-name": classText
          }
        }
        if(!classText) {
          delete elementAttribute.attrs["class-name"]
        }
        Transforms.setNodes(editor, elementAttribute, { at: path })
    }
  } 
}

export const setElementId = (editor, idText, selection) => {
  if (!selection) return
  if (Range.isCollapsed(selection)) {
    for (const [node, path] of Editor.nodes(editor, { at: selection, match: (n: JsonNode) => Element.isElement(n) && !excludedElements.includes(n.type) })) {
      const oldAttributes = node.attrs
      const elementAttribute = {
        attrs: {
          ...oldAttributes,
          id: idText
        }
      }
      if(!idText) {
        delete elementAttribute.attrs.id
      }
        Transforms.setNodes(editor, elementAttribute, { at: path })
    }
  }

}

export const getElementClass = (editor, selection) => {
  if (selection.focus.path) {
    const attributes = Node.parent(editor, selection.focus.path).attrs
    if (attributes) {
      return attributes["class-name"]
    }
  }
}

export const getElementId = (editor, selection) => {
  if (selection.focus.path) {
    const attributes = Node.parent(editor, selection.focus.path).attrs
    if (attributes) {
      return attributes.id
    }
  }
}

/** inline level  */
export const setInlineClass = (editor, classText, selection) => {
  if (selection) {
    if(classText){
      Editor.addMark(editor, "classname", classText)
    }
    else{
      Editor.removeMark(editor, "classname")
    }
  }
}

export const setInlineId = (editor, idText, selection) => {
  if (selection) {
    if(idText){
      Editor.addMark(editor, "id", idText)
    }
    else{
      Editor.removeMark(editor, "id")
    }
  }
}

export const getInlineClass = (editor, selection) => {
  if (selection.focus.path) {
    const className = Node.leaf(editor, selection.focus.path)["classname"]
    if (className) {
      return className
    }
  }
}

export const getInlineId = (editor, selection) => {
  if (selection.focus.path) {
    const id = Node.leaf(editor, selection.focus.path)["id"]
    if (id) {
      return id
    }
  }
}